import React, { useMemo, useRef } from 'react';
import {
  faChalkboardTeacher,
  faHandshake,
  faHospitalUser,
  faLaptopCode,
  faUserDoctor,
} from '@fortawesome/free-solid-svg-icons';

import { GlowOrb } from '../../components/GlowOrb/GlowOrb';
import { scrollToRef } from '../../utils/scrollToRef';

import { Audiences } from './components/Audiences/Audiences';
import { Authors } from './components/Authors/Authors';
import { Footer } from './components/Footer/Footer';
import { Goal } from './components/Goal/Goal';
import { Hero } from './components/Hero/Hero';
import { LearningTrajectory } from './components/LearningTrajectory/LearningTrajectory';
import { Pricing } from './components/Pricing/Pricing';
import { Program } from './components/Program/Program';
import { Question } from './components/Question/Question';
import { Signup } from './components/Signup/Signup';
import { Speakers } from './components/Speakers/Speakers';
import { TopNav } from './components/TopNav/TopNav';
import { PROGRAM_SUBTITLE, PROGRAM_TRACKS } from './data/programTracks';

import st from './Main.module.css';

export const Main = () => {
  const heroRef = useRef(null);
  const programRef = useRef(null);
  const questionRef = useRef(null);

  const audiences = useMemo(
    () => [
      {
        icon: faUserDoctor,
        title: 'Для врачей',
        text: 'Понимание, как ИИ помогает в диагностике и лечении, и как снижает нагрузку.',
        bullets: ['Правовые аспекты ИИ', 'Виды применения и тренды', 'Лучшие практики внедрения'],
      },
      {
        icon: faHospitalUser,
        title: 'Для организаторов здравоохранения',
        text: 'Повышение эффективности внедрения ИИ в медицинских организациях.',
        bullets: [
          'Сценарии внедрения и инфраструктура',
          'Модель зрелости И11 и метрики',
          'План повышения доверия + информационная безопасность',
        ],
      },
      {
        icon: faLaptopCode,
        title: 'Для ИТ-специалистов',
        text: 'Практика внедрения и развёртывания ИИ-решений: локально и централизованно.',
        bullets: ['Алгоритмы развёртывания', 'Информационная безопасность', 'Основы разработки и валидации'],
      },
      {
        icon: faHandshake,
        title: 'Для вендоров',
        text: 'Подготовка мероприятий по внедрению медицинских систем и изделий с ИИ.',
        bullets: ['Процессы внедрения', 'Ожидания заказчика', 'Комплаенс и доверие'],
      }
    ],
    []
  );

  return (
    <div className={st.root} ref={heroRef}>
      <TopNav
        onTop={() => scrollToRef(heroRef)}
        onProgram={() => scrollToRef(programRef)}
        onQuestion={() => scrollToRef(questionRef)}
      />

      <main>
        <Hero />
        <Goal />
        <Audiences audiences={audiences} />

        <LearningTrajectory />

        <div ref={programRef}>
          <Program tracks={PROGRAM_TRACKS} subtitle={PROGRAM_SUBTITLE} />
        </div>

        <Speakers />
        <Pricing />
        <Authors />

        <Signup />

        <div ref={questionRef}>
          <Question />
        </div>
      </main>

      <Footer onTop={() => scrollToRef(heroRef)} onProgram={() => scrollToRef(programRef)} />

      <GlowOrb className={`${st.pageOrb} ${st.pageOrbG}`} />
      <GlowOrb className={`${st.pageOrb} ${st.pageOrbR}`} />
    </div>
  );
};
